import React from 'react'
import {
  Container,
  Menu,
  Dropdown,
  Icon,
} from 'semantic-ui-react'
import {
  NavLink,
  Link,
} from 'react-router-dom'

const SelectFooter = ({selections, currentSelectionName, onPickSelection}) => {
  const selection = selections.find(s=>s.id===currentSelectionName);
  const options = selections.map(s=>{return {value: s.id, text: s.id}});
  return (
    <Menu fixed='bottom' color='orange' inverted>
      <Container>
        <Menu.Item as={NavLink} to="/selections">Selections</Menu.Item>
        {
          selections.length
          ?
          <Menu.Item>
            <Dropdown
              item
              search
              selection
              placeholder='Choose a selection'
              options={options}
              value={currentSelectionName}
              onChange={(e, {value})=>onPickSelection(value)}
            />
          </Menu.Item>
          :
          <Menu.Item as={NavLink} exact to='/new-selection'>Create New Selection</Menu.Item>
        }
        {
          selection
          ?
          <Menu.Menu position='right'>
            <Menu.Item as={Link} to={'/selection/'+currentSelectionName}>
              {Object.keys(selection.items).length}
              &nbsp; Items
            </Menu.Item>
            <Menu.Item as={NavLink} exact to={'/selection/'+currentSelectionName+''}>View</Menu.Item>
            <Menu.Item as={NavLink} to={'/selection/'+currentSelectionName+'/settings'}>Settings</Menu.Item>
            <Menu.Item as={NavLink} to={'/selection/'+currentSelectionName+'/export'}>Export</Menu.Item>
          </Menu.Menu>
          :
            selections.length
            ?
            <Menu.Menu position='right'>
              <Menu.Item header>
                <Icon name='info circle'/>
                Pick a selection
              </Menu.Item>
            </Menu.Menu>
            :
            <Menu.Menu position='right'>
              <Menu.Item header>
                <Icon name='info circle'/>
                You don't have any selections yet
              </Menu.Item>
            </Menu.Menu>
        }
      </Container>
    </Menu>
  );
}

export default SelectFooter